import React from 'react';
import clsx from 'clsx';
export const InlineLoader = React.forwardRef(function InlineLoader(props, ref) {
    const { className } = props;
    return (React.createElement("div", { className: clsx('inline-block relative opacity-30', className), ref: ref },
        React.createElement("div", { className: "spinner w-6 h-6 text-black" },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
});
